import { render, staticRenderFns } from "./management-library-physical-storage-category-view.vue?vue&type=template&id=6136aef0"
import script from "./management-library-physical-storage-category-view.vue?vue&type=script&lang=js"
export * from "./management-library-physical-storage-category-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports